import type { ItemFilter } from "@csf/shared";

export const CSFLOAT_DB_BASE = "https://csfloat.com/db";

// Стабильный построитель URL для csfloat.com/db.
//
// Источник правды по форматам query-параметров — оригинальные ссылки сайта:
//   sticker:  ?stickers=[{"i":"5936"}]
//   keychain: ?keychains=[{"i":64}]
//   skin:     ?name=...&defIndex=16&paintIndex=1255&min=0&max=1
//
// ВАЖНО:
// - для sticker значение i — строка ("5936"), для keychain — число (64).
//   Это поведение CSFloat, не наша вольность. Не трогать без подтверждения с сайта.
// - не используем URLSearchParams: он энкодит пробел как "+", а в copy-paste ссылках
//   с самого сайта пробелы — это %20. Делаем encodeURIComponent вручную, чтобы URL,
//   который мы строим, совпадал с тем, что юзер копирует из браузера.
export function buildDbUrl(filter: ItemFilter): string {
  const query = buildQuery(filter);
  return `${CSFLOAT_DB_BASE}?${query}`;
}

function buildQuery(filter: ItemFilter): string {
  switch (filter.kind) {
    case "sticker":
      return `stickers=${encodeURIComponent(JSON.stringify([{ i: filter.stickerId }]))}`;
    case "keychain":
      return `keychains=${encodeURIComponent(JSON.stringify([{ i: filter.keychainId }]))}`;
    case "skin": {
      const parts = [
        `name=${encodeURIComponent(filter.name)}`,
        `defIndex=${filter.defIndex}`,
        `paintIndex=${filter.paintIndex}`,
      ];
      // CSFloat /db: 1=Normal, 2=StatTrak, 3=Souvenir. Опускаем при undefined.
      if (filter.category) {
        const cat = filter.category === "normal" ? 1 : filter.category === "stattrak" ? 2 : 3;
        parts.push(`category=${cat}`);
      }
      parts.push(`min=${formatFloat(filter.min)}`, `max=${formatFloat(filter.max)}`);
      return parts.join("&");
    }
    default: {
      const _exhaustive: never = filter;
      throw new Error(`Unknown filter kind: ${JSON.stringify(_exhaustive)}`);
    }
  }
}

// CSFloat ожидает простую десятичную форму ("0", "0.5", "1"), без научной нотации.
// Number.toString() уже даёт нужный формат для разумных значений [0..1].
function formatFloat(n: number): string {
  return n.toString();
}
